
import './App.css';
import React, { useRef, useState, useEffect } from 'react';
import { flushSync } from 'react-dom';
import ChatMessage from './components/chat/ChatMessage';
import ChatHistory from './components/chat/ChatHistory';
import ChatInput from './components/chat/ChatInput';
import ChatWelcome from './components/chat/ChatWelcome';
import SuggestedQuestions from './components/chat/SuggestedQuestions';
import { API_URL, isProd } from './config';
import Greeting from './components/layout/Greeting';

import TopBar from './components/layout/TopBar';
import IssueFeedback from './components/feedback/IssueFeedback';

const ChatUI = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const userId = queryParams.get("userId") || (isProd ? "" : "55555");
  const productType = queryParams.get("productType") || (isProd ? "" : "5");
  const param = queryParams.get("param");
  const emailFromUrl = queryParams.get("email") || "";
  const phoneFromUrl = queryParams.get("phone") || "";

  const [conversationId, setConversationId] = useState("");
  const [messages, setMessages] = useState([]);
  const [messagesHistroy, setMessagesHistroy] = useState([]);
  const [loadingText, setLoadingText] = useState('Generating, please wait');
  const [isWaitingForAI, setWaitingForAI] = useState(false);
  const [submittedMsgIds, setSubmittedMsgIds] = useState(new Set());
  const savedScrollRef = useRef(0);
  const chatHistoryRef = useRef(null);
  const chatMainRef = useRef(null);
  const dotsIntervalRef = useRef(null);
  const sendMessageRef = useRef(null);
  const nextMessageIdRef = useRef(0);

  const getNextMessageId = () => {
    nextMessageIdRef.current += 1;
    return nextMessageIdRef.current;
  };

  const handleSendMessage = (message, bUser, bError = false, answer, isStreaming, settingTool, noSubmitButton = false) => {
    if (isStreaming === 0) {
      const messageId = getNextMessageId();
      setMessages(prev => [...prev, { id: messageId, text: "", isUser: false, isError: false, isComplete: false }]);
    }
    else if (isStreaming === 1) {
      try {
        // C. 核心：更新数组中最后一个助手的消息内容
        //console.log("Streaming message chunk:", message);
        flushSync(() => {
          setWaitingForAI(false);
          setMessages(prev => {
            const newMessages = [...prev];
            const lastIdx = newMessages.length - 1;
            // 找到刚才那个占位对象并追加文本
            newMessages[lastIdx] = {
              ...newMessages[lastIdx],
              text: newMessages[lastIdx].text + message,
              tool: settingTool
            };
            return newMessages;
          });
        });

      } catch (e) {
        console.error("解析流式JSON失败", e);
      }
    } else if (isStreaming === 2) {//调参
      flushSync(() => {
        setWaitingForAI(false);
        setMessages(prev => {
          const newMessages = [...prev];
          const lastIdx = newMessages.length - 1;
          // 找到刚才那个占位对象并追加文本
          newMessages[lastIdx] = {
            ...newMessages[lastIdx],
            text: message,
            tool: settingTool,
            isComplete: true
          };
          return newMessages;
        });
      });
    }
    else if (isStreaming === 3) {
      // 信号：渲染完成
      flushSync(() => {
        setWaitingForAI(false);
        setMessages(prev => {
          const newMessages = [...prev];
          if (newMessages.length > 0) {
            newMessages[newMessages.length - 1].isComplete = true;
          }
          return newMessages;
        });
      });
    }
    else {
      const messageId = getNextMessageId();
      setMessages(prevMessages => [...prevMessages, { id: messageId, text: message, isUser: bUser, isError: bError, answer: answer, tool: settingTool, isComplete: true, noSubmitButton }]);
      if (bUser) setWaitingForAI(true);
    }
  };


  const onButtonClick = (value) => {
    console.log("onButtonClick: " + value)
    if (sendMessageRef.current) {
      sendMessageRef.current.ParentHandleSendMessage(value, productType);
    }
  }

  const getDetailList = async (conversationIdTemp) => {
    let httpRequest = new XMLHttpRequest();
    httpRequest.open('GET', `${API_URL}/users/${userId}/conversations/${conversationIdTemp}/messages?page=1&count=10`, true);
    httpRequest.send();

    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        let json = httpRequest.responseText;
        callbackGetListDetail(json);
      } else {
        console.error(`Request failed with status: ${httpRequest.status},httpRequest.readyState: ${httpRequest.responseText}`);
      }
    };
  }

  function callbackGetListDetail(json) {
    try {
      let jsonObject = window.JSON.parse(json);
      console.log(jsonObject)
      if (jsonObject.code === 200 && jsonObject.data) {

        // --- 开始重新映射 ---
        const mappedList = jsonObject.data.list.map((item, index) => {
          return {
            question: item.humanMessage,
            answer: item.aiMessage,
            createdAt: new Date().toLocaleTimeString(), // 添加新字段
            earSide: item.earSide,
            tool: { strategy: item.soundAdjustmentStrategy, leftOrRight: item.earSide, value: item.value },
            id: index
          };
        });

        if (mappedList === undefined || mappedList === null || mappedList.length === 0) {
          setMessagesHistroy([]);
          console.log('No data');
        }
        else {
          setMessagesHistroy(mappedList);
        }
      }
    } catch (error) {
      // 如果上面的操作抛出异常，这里的代码将会执行
      console.error('Error during data fetching:', error);
    }
  };

  function callbackGetList(json) {
    try {
      let jsonObject = window.JSON.parse(json);
      console.log(jsonObject)
      if (jsonObject.code === 200) {
        let conversations = jsonObject.data;
        if (conversations === undefined || conversations === null || conversations.length === 0) {
          setMessagesHistroy([]);
          console.log('No conversations');
          return;
        }
        let lastConversation = conversations.today;
        if (lastConversation === undefined || lastConversation === null || lastConversation.length === 0) {
          lastConversation = conversations.thisWeek;
          if (lastConversation === undefined || lastConversation === null || lastConversation.length === 0) {
            lastConversation = conversations.earlier;
          }
        }
        //console.log("Last conversation:", lastConversation);
        let conversationIdTemp = lastConversation[0].id;
        console.log("Last conversation conversationIdTemp:", conversationIdTemp);
        setConversationId(conversationIdTemp);
        getDetailList(conversationIdTemp);
      }
    } catch (error) {
      // 如果上面的操作抛出异常，这里的代码将会执行
      console.error('Error during data fetching:', error);
    }
  };

  const getHistoryList = async (callback, fingerprintTmp, productType) => {
    let httpRequest = new XMLHttpRequest();
    console.log("Fetching history list with fingerprint:", fingerprintTmp, "and productType:", productType);
    httpRequest.open('GET', `${API_URL}/users/${fingerprintTmp}/${productType}/conversations`, true);
    httpRequest.send();

    httpRequest.onreadystatechange = function () {//
      if (httpRequest.readyState === 4 && httpRequest.status === 200) {
        let json = httpRequest.responseText;
        callback(json);
      } else {
        console.error(`Request failed with status: ${httpRequest.status},httpRequest.readyState: ${httpRequest.readyState}`);
      }
    };
  }


  // 在组件挂载后和 messages 更新后滚动到底部
  useEffect(() => {
    dotsIntervalRef.current = setInterval(() => {
      setLoadingText((prevText) => {
        // 根据当前文本决定下一个文本
        switch (prevText) {
          case 'Let me think for a moment':
            return 'Let me think for a moment.';
          case 'Let me think for a moment.':
            return 'Let me think for a moment..';
          case 'Let me think for a moment..':
            return 'Let me think for a moment...';
          case 'Let me think for a moment...':
          default:
            return 'Let me think for a moment';
        }
      });
    }, 500);

    // 清除定时器，防止在组件卸载时内存泄漏
    return () => clearInterval(dotsIntervalRef.current);
  }, [messages]);

  const hasCalled = useRef(false); // 标记是否已调用
  // 处理一次性调用的 useEffect
  useEffect(() => {
    // 一次性调用逻辑
    console.log('This runs only once when the component mounts');
    if (!hasCalled.current) {
      hasCalled.current = true;
      if (param !== '' && param !== null && sendMessageRef.current) {
        sendMessageRef.current.ParentHandleSendMessage(param, productType);
      }
      getHistoryList(callbackGetList, userId, productType);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 空数组表示只在组件挂载时运行一次

  useEffect(() => {
    // 等待下一次事件循环，以确保DOM已经更新
    setTimeout(() => {
      if (chatHistoryRef.current) {
        // 将页面滚动到聊天窗口底部
        window.scrollTo({
          top: chatHistoryRef.current.offsetTop + chatHistoryRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 0);
  }, [messages, messagesHistroy]); // 依赖数组messages和messagesHistroy

  const handleNewChat = () => {
    setCurrent("Main");
    setConversationId("");
    if (sendMessageRef.current) {
      sendMessageRef.current.childFunction();
    }
    console.log("Starting new chat, conversationId reset to empty.", conversationId);
    setMessages([]);
    setMessagesHistroy([]);
  }

  const [current, setCurrent] = useState("Main");


  const handleSubmit = (msgId) => {
    savedScrollRef.current = window.scrollY;
    setCurrent("IssueFeedback");
    window.scrollTo({ top: 0, behavior: 'instant' });
    if (msgId !== undefined) {
      setTimeout(() => {
        setSubmittedMsgIds(prev => new Set([...prev, msgId]));
      }, 500);
    }
  }

  const handleBackPro = () => {
    setCurrent("Main");
    setTimeout(() => {
      window.scrollTo({ top: savedScrollRef.current, behavior: 'instant' });
    }, 0);
  }

  const handleSubmitComplete = () => {
    setCurrent("Main");
    setTimeout(() => {
      handleSendMessage(
        "✅ Your request has been submitted. Our support team will review your request and contact you soon.",
        false, false, null, undefined, null, true
      );
    }, 100);
  };

  return (
    <div className="container" ref={chatMainRef}>
      <div className="top-container" >
        <TopBar handleNewChat={handleNewChat} handleBack={handleBackPro} bShowBackButton={current === "IssueFeedback"}></TopBar>
      </div>
      <div style={{ display: current === "Main" ? '' : 'none' }}>
      <Greeting></Greeting>
        <div>
          <div className="chat-container" ref={chatHistoryRef}>
            <div className="chat-history-history">
              {/* {
            messagesHistroy.length === 0 &&  messages.length === 0 &&
            (<div>
              <ChatWelcome />
              
            </div>)
          } */}

              {messagesHistroy.length === 0 && messages.length === 0 &&
                <div>
                  <SuggestedQuestions onClick={onButtonClick} productType={productType}></SuggestedQuestions>
                </div>
              }

              {messagesHistroy.slice(-10).reduce((acc, msg, index) => {
                const prevMsg = acc.length > 0 ? acc[acc.length - 1].props.message.createdAt : null;

                acc.push(
                  <ChatHistory
                    key={index}
                    message={msg}
                    prevUpdatedAt={prevMsg}
                    tool={msg.tool}
                    onSubmit={handleSubmit}
                  />
                );
                return acc;
              }, [])}
            </div>

            <div className="chat-history" >
              {messages.map((msg) => {
                const isLastTool = [...messages].reverse().find(m => m.tool)?.id === msg.id;
                return (
                  <ChatMessage key={msg.id} msgId={msg.id} message={msg.text} isUser={msg.isUser}
                    isError={msg.isError} answers={msg.answer} tool={msg.tool} isLast={isLastTool} onSubmit={handleSubmit}
                    isComplete={msg.isComplete} isSubmitted={submittedMsgIds.has(msg.id)} noSubmitButton={msg.noSubmitButton} />);

              })}
            </div>

            {isWaitingForAI && (
              <div className='container-left'>
                <label className='AIHeadLabel'>
                </label>

                <div className='chat-message-bot'>
                  {loadingText}
                </div>
              </div>
            )}

            {
              messagesHistroy.length + messages.length <= 2 &&
              (<div>
                <div className="footer-placeholder"></div>
                <div className="footer-placeholder"></div>
              </div>)
            }
          </div>
          <div className="footer-placeholder"></div>
          <div className="input-container">
            <ChatInput ref={sendMessageRef}
              onSendMessage={handleSendMessage} userConversationId={conversationId} onSubmit={handleSubmit}
              userId={userId} productType={productType} />
          </div>
        </div>
      </div>
      {current === "IssueFeedback" && <IssueFeedback onRequestComplete={handleSubmitComplete} productType={productType} defaultEmail={emailFromUrl} defaultPhone={phoneFromUrl} />}

    </div>

  );
};



function App() {
  return (
    <div className="App">
      <header className="App-header">
        <ChatUI></ChatUI>
      </header>
    </div>
  );
}

export default App;
